
<div class="status-display p-1">

  <div class="pb-3">
    <div class="id-info text-break">
      @if (antragTicketId && antragTicketId !== undefined && antragTicketId !== null) {
        <h4 class="m-2">
          {{ "STANDARD.TICKET_ANTRAG" | translate }}{{'STANDARD.SNUMMER' | translate}}
          <div class="text-end default-text-size" data-cy="antragticket-id">{{ this.antragTicketId }}</div>
        </h4>
      } @else {
        <h4 class="m-2">
          {{ "STANDARD.TICKET_ANTRAG" | translate }}
        </h4>
      }
    </div>
  </div>

  @if (hasPostkorbChannel(antragTicket)) {
    <h4 class="text-break">
      {{ "TICKETDETAIL.POSTKORB_REFERENCE" | translate }} {{ postkorbReference }}
    </h4>
  }

  @if (antragTicket?.status == draftStatus || !antragTicketId) {
    <h4 class="text-break">
      {{"TICKETDETAIL.ANTRAGSTATUS" | translate}}
    </h4>
  }
  @if (antragTicket?.status == draftStatus || !antragTicketId) {
    <div class="alert alert-info antrag-status text-break" role="alert">
      <p><fa-icon [icon]="faInfo"></fa-icon>
      {{"TICKETDETAIL.STATUS.ENTWURF" | translate}}
    </p>
    @if (!antragTicketId) {
      <span class="alert warning"> {{('STANDARD.NOT_SAVED'|translate)}} </span>
    }
  </div>
}
@if (antragTicket?.antragsdatum !== null) {
  <div class="alert alert-info antrag-status text-break" role="alert">
    <p><i class="fa fa-info-circle"></i>
    {{"TICKETDETAIL.STATUS.EINGEREICHT" | translate}} {{antragTicket?.antragsdatum | date:'dd.MM.yyyy'}}.
  </p>
</div>
}
@if (antragTicket?.bestelldatum !== null) {
  <div class="alert alert-info antrag-status text-break" role="alert">
    <p><i class="fa fa-info-circle"></i>
    {{"TICKETDETAIL.STATUS.BESTELLT" | translate}} {{antragTicket?.bestelldatum | date:'dd.MM.yyyy'}}.
  </p>
</div>
}
@if (antragTicket?.ausgabedatum !== null) {
  <div class="alert alert-info antrag-status text-break" role="alert">
    <p><i class="fa fa-info-circle"></i>
    {{"TICKETDETAIL.STATUS.AUSGEGEBEN" | translate}} {{antragTicket?.ausgabedatum | date:'dd.MM.yyyy'}}.
  </p>
</div>
}
</div>

<div ngbAccordion>
  <div ngbAccordionItem>
    <h2 ngbAccordionHeader>
      <button ngbAccordionButton>{{ 'STANDARD.ATTACHMENTS' | translate }}  <span class="badge badge-pill badge-dark ms-2 "  >
        {{antragTicket?.attachments?.length || '0'}}
      </span>
    </button>
  </h2>
  <div ngbAccordionCollapse>
    <div ngbAccordionBody>
      <ng-template>
        <app-ticket-antrag-sidebar-attachments
          [antragTicketId]="antragTicketId"
          [deleteable]="antragTicket?.status === 'ENTWURF'"
          [appendable]="antragTicket?.status === 'ENTWURF'"
          [allowedTypesForSelection]="allowedTypesForSelection"
        ></app-ticket-antrag-sidebar-attachments>
      </ng-template>
    </div>
  </div>
</div>
</div>
